import { render, staticRenderFns } from "./EdenConfirmDialog.vue?vue&type=template&id=125baf06&scoped=true"
import script from "./EdenConfirmDialog.vue?vue&type=script&lang=js"
export * from "./EdenConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125baf06",
  null
  
)

export default component.exports